export const SendCustomerDataTexts = {
  errorTitle: 'Не удалось сохранить данные',
  errorDescription: 'Попробуйте перезагрузить страницу',
};
